import React from 'react';

export default function UserAvatar({ name, role, size = "md", src }) {
  const initials = name ? name.split(' ').map(n => n[0]).join('').toUpperCase() : 'AD';
  
  const sizes = {
    sm: "w-8 h-8 text-[10px]",
    md: "w-10 h-10 text-xs",
    lg: "w-14 h-14 text-lg"
  };

  const colors = [
    'bg-blue-600', 'bg-orange-600', 'bg-indigo-600', 'bg-slate-700'
  ];
  
  const bgColor = colors[initials.charCodeAt(0) % colors.length];

  return (
    <div className="flex items-center gap-3">
      <div className={`${sizes[size]} rounded-full flex items-center justify-center font-bold text-white border-2 border-slate-700 shadow-inner overflow-hidden ${bgColor}`}>
        {src ? (
          <img 
            src={src} 
            alt={name} 
            className="w-full h-full object-cover"
            onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
          />
        ) : null}
        <span style={{ display: src ? 'none' : 'flex' }}>{initials}</span>
      </div>
      {(name || role) && (
        <div className="hidden md:block text-left">
          {name && <p className="text-sm font-semibold text-slate-200 leading-none mb-1">{name}</p>}
          {role && <p className="text-[10px] font-mono text-slate-500 uppercase tracking-tighter">{role}</p>}
        </div>
      )}
    </div>
  );
}